class ServiceWorkerNotifications {
    
    static registerCallback(callback) {
        ServiceWorkerNotifications.callback = callback
    }

    static dispatchCallback(data) {
        let _callback = ServiceWorkerNotifications.callback
        _callback(data)
    }

    static callback;

}
export default ServiceWorkerNotifications;